// tslint:disable-next-line:no-any
export function crearError<E extends Error, Args extends any[]>(
    nombre: string,
    constructorFn: (this: E, ...args: Args) => void,
) {
    function ErrorConstructor(this: E, ...args: Args) {
        constructorFn.apply(this, args);

        Object.defineProperty(this, 'message', {
            enumerable: false,
            value: this.message,
        });

        // istanbul ignore if
        if (!Error.captureStackTrace) {
            const e = new Error(this.message);
            e.name = nombre;
            Object.defineProperty(this, 'stack', {
                enumerable: false,
                value: e.stack,
            });
            return;
        }

        Error.captureStackTrace(this, ErrorConstructor);
    }

    Object.defineProperty(ErrorConstructor, 'name', {
        writable: false,
        value: nombre,
    });

    ErrorConstructor.prototype = Object.create(Error.prototype);
    ErrorConstructor.prototype.constructor = ErrorConstructor;
    ErrorConstructor.prototype.name = nombre;

    return (ErrorConstructor as unknown) as {
        readonly prototype: E;
        new (...args: Args): E;
    };
}

export function concatenarUrl(base: string, resto: string): string {
    return (base.slice(-1) === '/' ? base.slice(0, -1) : base) + resto;
}



// WEBPACK FOOTER //
// ./src/api/clienteApi/utilidades.ts